import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";
import axios from 'axios';
import NaturalPersonRegisterForm from "./NaturalPersonRegisterForm";
import CompanyRegisterForm from "./CompanyRegisterForm";
import { apiBaseUrl, checkMail, checkSponsor } from "../services/api";
import { validateEmail } from "../functions/functions";
import { useToasts } from "../hooks/useToasts";
import { Turnstile } from "@marsidev/react-turnstile";
import { useSearchParams } from "react-router-dom";
import Button from './ui/buttons/Button';
import PageWrapper from './ui/wrappers/PageWrapper';

const TURNSTILE_SECRET = process.env.REACT_APP_SITEKEY_TURNSTILE;
const pretupClientSpace = process.env.REACT_APP_USER_DASHBOARD;


const Register = ({ onRequestClose }) => {
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [email, setEmail] = useState('');
    const [birthdate, setBirthdate] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [siren, setSiren] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [sponsorCode, setSponsorCode] = useState('');
    const [promoCode, setPromoCode] = useState('');
    const [formType, setFormType] = useState('naturalPersonRegisterForm');
    const [error, setError] = useState(null);
    const [isCguAccepted, setIsCguAccepted] = useState(false);
    const [isLemonwayCguAccepted, setIsLemonwayCguAccepted] = useState(false);
    const [isMailCheckingByApi, setIsMailCheckingByApi] = useState(false);
    const [isSponsorCodeChecking, setIsSponsorCodeChecking] = useState(false);
    const [isEmailUsed, setIsEmailUsed] = useState(false);
    const [isSponsorCodeValid, setIsSponsorCodeValid] = useState(false);
    const [civilite, setCivilite] = useState('M');
    const { pushToast } = useToasts();
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState(null);
    const [provenance, setProvenence] = useState('');
    const [origine, setOrigine] = useState('');
    const [alertSponsorCode, setAlertSponsorCode] = useState(null);
    const [searchParams] = useSearchParams();
    const [step, setStep] = useState(1);
    const isReactSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
    const isDev = process.env.NODE_ENV === 'development';
    const isCaptchaEnabled = !isDev && !isReactSnap;

    // Si l'utilisateur a été redirigée ici depuis
    // la page /dynamisez-votre-epargne-jusqu-a-11-pourcent (landing)
    useEffect(() => {
        if (location.state?.form) {
            const form = location.state.form;

            if (form.firstname) {
                setFirstName(form.firstname);
            }
            if (form.lastname) {
                setLastName(form.lastname);
            }
            if (form.email) {
                setEmail(form.email);
            }
            if (form.provenance) {
                setProvenence(form.provenance);
            }
            if (form.origine) {
                setOrigine(form.origine);
            }
            setStep(3);

            // On "simule" une redirection vers cette même page
            // en nettoyant le state, cela evite le remplissage
            // du form quand l'utilisateur actualise la page.
            navigate(".", { replace: true, state: {} });
        }
    }, [location.state])

    // Gestion de queryParams
    useEffect(() => {
        const code = searchParams.get("code") || "";
        const mail = searchParams.get("mail") || "";
        if (code) setSponsorCode(code);
        if (mail) setEmail(mail);

        (async () => {
            if (mail) await handleCheckMailApi(mail);
            if (mail && code) await checkSponsorCode(mail, code);
        })();
    }, [searchParams]);

    const handleEmailBlur = async () => {
        if (error === "Cet email est déjà utilisé") {
            setError(null);
        }

        const isMailValid = await handleCheckMailApi(email);

        if (sponsorCode) {
            if (isMailValid) {
                await checkSponsorCode();
            } else {
                setAlertSponsorCode({ type: "error", message: "Vous devez renseigner un email valide pour profiter du code parrain." });
            }
        } else {
            setAlertSponsorCode(null);
        }
    };


    const handleCheckMailApi = async (email) => {
        if (!isMailCheckingByApi && validateEmail(email)) {

            setIsMailCheckingByApi(true);
            const isValid = await checkMail(email);
            setIsMailCheckingByApi(false);

            if (isValid) {
                setIsEmailUsed(false);
                if (error === "Cet email est déjà utilisé") {
                    setError("");
                }
                return true;
            } else {
                setIsEmailUsed(true);
                setError("Cet email est déjà utilisé");
                return false;
            }
        }
    }
    const handleNaturalPersonSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        // if (status !== 'solved') {
        //     setError('⚠ Captcha incorrect ⚠');
        //     return;
        // }

        if (!validateNaturalPersonForm()) {
            return;
        }

        const datas = {
            statutlegal: 'physique',
            firstname: firstName,
            lastname: lastName,
            password: password,
            password2: confirmPassword,
            birthdate: birthdate,
            email: email,
            civilite: civilite,
            valid_cgu: true,
            valid_smoney: true,
            provenance: provenance,
            origine: origine,
        }


        if (sponsorCode) {
            datas.codeParrain = sponsorCode;
        }

        if (promoCode) {
            datas.codePromo = promoCode;
        }

        try {
            const response = await axios.post(`${apiBaseUrl}/register/lender`, datas);
            const { message } = response.data;
            const middleMessage = "Si vous n'avez pas reçu ce mail, pensez à vérifier votre dossier Spams.";
            const endMessage = "Redirection vers la page de connexion...";

            setError("");
            pushToast({
                content: <span>{message}  <br />
                    <span className='font-normal'>{middleMessage}</span><br />
                    <span className='font-normal'>{endMessage}</span>
                </span>,
                type: "success",
                position: "topCenter",
                duration: 11,
                iconSize: 50
            });
            clearForm();
            setTimeout(() => {
                window.location.assign(`${pretupClientSpace}/login.php`);
            }, 11000);

        } catch (error) {
            let message = '';

            if (process.env.NODE_ENV === 'development') {
                console.error('API Error:', error.response ? error.response.data : error.message);
            }
            const datas = error.response.data;
            if (datas.message) {
                message = datas.message;
            } else if (datas.violations) { // SI erreur levée par dto de symfony
                message = datas.violations[0].title;
            } else {
                message = error.message || "";
            }

            setError('Erreur lors de l\'inscription : ' + message);
        }
    };

    const handleCompanySubmit = async (e) => {
        e.preventDefault();
        if (!validateCompanyForm()) {
            return;
        }

        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const datas = {
            civilite: civilite,
            statutlegal: 'morale',
            firstname: firstName,
            lastname: lastName,
            password: password,
            password2: confirmPassword,
            birthdate: birthdate,
            email: email,
            companyName: companyName,
            siren: siren,
            valid_cgu: true,
            valid_smoney: true,
            provenance: provenance,
            origine: origine,
        }

        if (sponsorCode) {
            datas.codeParrain = sponsorCode;
        }

        if (promoCode) {
            datas.codePromo = promoCode;
        }

        try {
            const response = await axios.post(`${apiBaseUrl}/register/lender/company`, datas);
            const { message } = response.data;
            const middleMessage = "Si vous n'avez pas reçu ce mail, pensez à vérifier votre dossier Spams.";
            const endMessage = "Redirection vers la page de connexion...";

            setError("");
            pushToast({
                content: <span>{message}  <br />
                    <span className='font-normal'>{middleMessage}</span><br />
                    <span className='font-normal'>{endMessage}</span>
                </span>,
                type: "success",
                position: "topCenter",
                duration: 11,
                iconSize: 50
            });
            clearForm();
            setTimeout(() => {
                window.location.assign(`${pretupClientSpace}/login.php`);
            }, 11000);

        } catch (error) {

            console.error('API Error:', error.response ? error.response.data : error.message);
            const message = error.response ? error.response.data.message : error.message;
            setError('Erreur lors de l\'inscription : ' + message);
        }
    };

    const validateNaturalPersonForm = () => {

        if (!validateFirstName()) {
            return false;
        }

        if (!validateLastName()) {
            return false;
        }

        // if (!validateBirthdate(birthdate, setError)) {
        //     return false;
        // }

        if (!isLastnameFirstnameDifferents()) {
            setError("Le nom et le prénom doivent être différents");
            return false;
        }

        if (!validateEmail(email)) {
            setError("L'email n'est pas valide");
            return false;
        }

        if (isEmailUsed) {
            setError("L'email est déjà utilisé");
            return false;
        }

        if (isMailCheckingByApi) {
            setError("L'email est en cours de vérification. Réessayez dans 5 secondes.");
            return false;
        }

        if (!civilite) {
            setError("La civilite est requise");
            return false
        }

        if (!isAdult()) {
            setError("Vous devez être majeur pour pouvoir vous inscrire");
            return false;
        }

        if (!passwordsMatch()) {
            setError("Les deux mots de passe doivent être identiques");
            return false;
        }

        if (!validatePassword()) {
            setError("Le mot de passe ne satisfait pas les critères");
            return false;
        }

        if (!isCguAccepted) {
            setError("Vous devez accepter les conditions générales d'utilisation");
            return false;
        }

        if (!isLemonwayCguAccepted) {
            setError("Vous devez accepter les conditions générales de l'établissement de payement");
            return false;
        }

        return true;
    }

    const validateCompanyForm = () => {
        if (!validateNaturalPersonForm()) {
            return false;
        }

        if (!validateSiren()) {
            return false;
        }

        if (!validateCompanyName()) {
            return false;
        }

        return true;
    }

    const onConnexionBtnCLick = () => {
        window.location.assign(`${pretupClientSpace}/login.php`);
    };

    const isAdult = () => {
        const birthDate = new Date(birthdate);

        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        // Vérifier si l'anniversaire de cette année est passé
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= 18;
    }

    const isLastnameFirstnameDifferents = () => {
        return firstName !== lastName;
    }

    const validatePassword = () => {
        return (
            password.length >= 12 &&
            /[A-Z]/.test(password) &&
            /\d/.test(password) &&
            /[@$!%*?&_\-#^+=(){}[\]:;"'<>,./\\|~`]/.test(password) &&
            passwordsMatch()
        );
    };

    const passwordsMatch = () => {
        if (password.length > 0 && confirmPassword.length > 0) {
            return password === confirmPassword;
        } else {
            return false;
        }
    };

    const clearForm = () => {
        setLastName('');
        setFirstName('');
        setEmail('');
        setBirthdate('');
        setPassword('');
        setConfirmPassword('');
        setCivilite('');
        setSiren('');
        setCompanyName('');
        setSponsorCode('');
        setPromoCode('');
        setError(null);
        setIsCguAccepted(false);
        setIsLemonwayCguAccepted(false);
        setAlertSponsorCode(null);
    };


    /**
     * Fais un appel api pour vérifier le code parrain
     * 
     * Nettoye l'erreur si nécessaire
     */
    const checkSponsorCode = async (email, sponsorCode) => {
        if (isSponsorCodeChecking) {
            setAlertSponsorCode("Code en cours de validation, veuillez patienter...");
        } else if (sponsorCode) {
            setAlertSponsorCode(null);
            if (!email ||
                isEmailUsed ||
                !validateEmail(email)
            ) {
                setAlertSponsorCode({ type: "error", message: "Vous devez renseigner un email valide pour profiter du code parrain." });
            } else {

                setIsSponsorCodeChecking(true);
                const response = await checkSponsor(sponsorCode, email);
                if (response.isValid) {
                    setAlertSponsorCode({ type: "success", message: "Code Parrain valide" });
                    setIsSponsorCodeValid(true);
                } else {
                    if (response.message === "Le code parrain est incorrect.") {
                        setAlertSponsorCode({ type: "error", message: "Code Parrain invalide, vérifiez la saisie de votre Email et du Code Parrain" });
                    } else {
                        setAlertSponsorCode({ type: "warning", message: "Impossible de vérifier le Code Parrain, vérifiez la saisie de votre Email et du Code Parrain" });
                    }
                }
                setIsSponsorCodeChecking(false);
            }
        }
    }

    const handleSponsorCodeBlur = () => {
        checkSponsorCode(email, sponsorCode);
    }

    /**
     * Renvoie true ou l'erreur sous forme de string
     * @returns {boolean|string}
     */
    const validateFirstName = () => {
        const withoutSpaces = firstName.replace(/\s+/g, "");
        if (withoutSpaces.length <= 2) {
            setError("Le prénom doit contenir plus de 2 caractères  (espaces exclus)");
            return false;
        }

        if (/\d/.test(firstName)) {
            setError("Le prénom ne doit pas contenir de chiffres");
            return false;
        }

        return true;
    }

    /**
     * Renvoie true ou l'erreur sous forme de string
     * @returns {boolean|string}
     */
    const validateLastName = () => {
        const withoutSpaces = lastName.replace(/\s+/g, "");
        if (withoutSpaces.length <= 2) {
            setError("Le nom doit contenir plus de 2 caractères (espaces exclus)");
            return false;
        }

        if (/\d/.test(lastName)) {
            setError("Le nom ne doit pas contenir de chiffres");
            return false;
        }

        return true;
    }

    const validateSiren = () => {
        if (siren.length !== 9) {
            setError("Le n° de SIREN doit comporter 9 caractères");
            return false;
        } else {
            return true;
        }
    }

    const validateCompanyName = () => {
        return !!companyName;
    }

    const validateBirthdate = (dateString, setError = null) => {
        if (!dateString) {
            setError?.("Date de naissance incorrecte.")
            return false;
        }

        const birthDate = new Date(dateString);

        if (isNaN(birthDate.getTime())) {
            setError?.("Date de naissance incorrecte.");
            return false;
        }
        if (birthDate.getFullYear() <= 1925) {
            setError?.("L'année de naissance doit être supérieure à 1925.");
            return false;
        }

        return true;
    };

    const handleFormChange = (type) => {

        if (type === 'naturalPersonRegisterForm') {
            setFormType('naturalPersonRegisterForm');
        } else if (type === 'companyRegisterForm') {
            setFormType('companyRegisterForm');
        }
    }


    return (
        <PageWrapper>
            <div className="mb-6 md:mb-12 md:mx-auto md:w-3/5">
                <h2 className="mb-4 text-3xl text-secondary">Inscrivez-vous pour investir dans les PME</h2>
                <p className={"mb-5 text-lg"}>Rejoignez une communauté d'investisseurs engagée, investissez dans l'économie réelle</p>
                <p className={"mb-5 text-lg"}>Inscription rapide, simple et sans frais</p>
                <p className={"mb-5 text-lg"}>Depuis 2015, PretUp permet de rendre les meilleures opportunités d’investissement dans les PME françaises accessibles à tout le monde</p>
                {step === 1 &&
                    <div className="mb-8">
                        <h3 className='mb-5 text-2xl text-secondary'>Vous souhaitez :</h3>
                        <div className="flex gap-10">
                            <Button
                                text={"Investir dans les entreprises françaises"}
                                tailwinClass={"w-1/2"}
                                size={"small"}
                                btnType={"secondary"}
                                hover={true}
                                handleClick={() => setStep(2)}
                            />
                            <Button
                                text={"Obtenir un financement"}
                                tailwinClass={"w-1/2"}
                                size={"small"}
                                btnType={"secondary"}
                                hover={true}
                                link={{ external: false, href: "/emprunteur/inscription", hash: true }}
                            />
                        </div>
                    </div>
                }
                {step === 2 &&
                    <div className="mb-8">
                        <h3 className='mb-5 text-2xl'>Vous êtes :</h3>
                        <div className="flex gap-10">
                            <Button
                                text={"Un particulier"}
                                tailwinClass={"w-1/2"}
                                size={"small"}
                                btnType={"secondary"}
                                hover={true}
                                handleClick={() => { setFormType("naturalPersonRegisterForm"); setStep(3); }}
                            />
                            <Button
                                text={"Une entreprise"}
                                tailwinClass={"w-1/2"}
                                size={"small"}
                                btnType={"secondary"}
                                hover={true}
                                handleClick={() => { setFormType("companyRegisterForm"); setStep(3); }}
                            />
                        </div>
                    </div>
                }
                {step === 3 && formType === "naturalPersonRegisterForm" &&
                    <>
                        <div className="mb-4 mt-2 block w-full max-w-2xl">
                            <p className="block text-sm font-medium my-2">Statut juridique de votre compte investisseur</p>
                            <div className="flex">
                                <Button
                                    text={"Personne physique"}
                                    tailwinClass={"w-48"}
                                    size={"xs"}
                                    btnType={formType === "naturalPersonRegisterForm" ? "secondary" : "transparentSecondary"}
                                    hover={true}
                                    handleClick={() => handleFormChange("naturalPersonRegisterForm")}
                                />
                                <Button
                                    text={"Personne morale"}
                                    tailwinClass={"w-48 ml-3"}
                                    size={"xs"}
                                    btnType={formType === "companyRegisterForm" ? "secondary" : "transparentSecondary"}
                                    hover={true}
                                    handleClick={() => handleFormChange("companyRegisterForm")}
                                />
                            </div>
                        </div>
                        <NaturalPersonRegisterForm lastName={lastName}
                            setLastName={setLastName}
                            firstName={firstName}
                            setFirstName={setFirstName}
                            email={email}
                            setEmail={setEmail}
                            onRequestClose={onRequestClose}
                            password={password}
                            setPassword={setPassword}
                            confirmPassword={confirmPassword}
                            handleSubmit={handleNaturalPersonSubmit}
                            birthdate={birthdate}
                            setBirthdate={setBirthdate}
                            setConfirmPassword={setConfirmPassword}
                            error={error}
                            setError={setError}
                            promoCode={promoCode}
                            setPromoCode={setPromoCode}
                            sponsorCode={sponsorCode}
                            setSponsorCode={setSponsorCode}
                            isCguAccepted={isCguAccepted}
                            setIsCguAccepted={setIsCguAccepted}
                            isLemonwayCguAccepted={isLemonwayCguAccepted}
                            setIsLemonwayCguAccepted={setIsLemonwayCguAccepted}
                            passwordsMatch={passwordsMatch}
                            handleEmailBlur={handleEmailBlur}
                            setCivilite={setCivilite}
                            civilite={civilite}
                            handleSponsorCodeBlur={handleSponsorCodeBlur}
                            alertSponsorCode={alertSponsorCode}
                            isMailCheckingByApi={isMailCheckingByApi}
                            isSponsorCodeChecking={isSponsorCodeChecking}
                        />
                        {isCaptchaEnabled && (
                        <Turnstile
                                siteKey={TURNSTILE_SECRET}
                                className={'mt-4 mx-auto max-w-fit'}
                                onError={() => setStatus('error')}
                                onExpire={() => setStatus('expired')}
                                onSuccess={() => setStatus('solved')}
                            />
                        )}
                </>
                }
                {step === 3 && formType === "companyRegisterForm" &&
                    <>
                        <div className="mb-4 mt-2 block w-full max-w-2xl">
                            <p className="block text-sm font-medium my-2">Statut juridique de votre compte investisseur</p>
                            <div className="flex">
                                <Button
                                    text={"Personne physique"}
                                    tailwinClass={"w-48"}
                                    size={"xs"}
                                    btnType={formType === "naturalPersonRegisterForm" ? "secondary" : "transparentSecondary"}
                                    hover={true}
                                    handleClick={() => handleFormChange("naturalPersonRegisterForm")}
                                />
                                <Button
                                    text={"Personne morale"}
                                    tailwinClass={"w-48 ml-3"}
                                    size={"xs"}
                                    btnType={formType === "companyRegisterForm" ? "secondary" : "transparentSecondary"}
                                    hover={true}
                                    handleClick={() => handleFormChange("companyRegisterForm")}
                                />
                            </div>
                        </div>
                        <CompanyRegisterForm lastName={lastName}
                            civilite={civilite}
                            setCivilite={setCivilite}
                            setLastName={setLastName}
                            firstName={firstName}
                            setFirstName={setFirstName}
                            email={email}
                            setEmail={setEmail}
                            onRequestClose={onRequestClose}
                            password={password}
                            setPassword={setPassword}
                            confirmPassword={confirmPassword}
                            handleSubmit={handleCompanySubmit}
                            birthdate={birthdate}
                            setBirthdate={setBirthdate}
                            setConfirmPassword={setConfirmPassword}
                            error={error}
                            setError={setError}
                            promoCode={promoCode}
                            setPromoCode={setPromoCode}
                            sponsorCode={sponsorCode}
                            setSponsorCode={setSponsorCode}
                            siren={siren}
                            setSiren={setSiren}
                            companyName={companyName}
                            setCompanyName={setCompanyName}
                            isCguAccepted={isCguAccepted}
                            setIsCguAccepted={setIsCguAccepted}
                            isLemonwayCguAccepted={isLemonwayCguAccepted}
                            setIsLemonwayCguAccepted={setIsLemonwayCguAccepted}
                            passwordsMatch={passwordsMatch}
                            handleEmailBlur={handleEmailBlur}
                            handleSponsorCodeBlur={handleSponsorCodeBlur}
                            alertSponsorCode={alertSponsorCode}
                            isMailCheckingByApi={isMailCheckingByApi}
                            isSponsorCodeChecking={isSponsorCodeChecking}
                        />
                        {isCaptchaEnabled && (
                        <Turnstile
                                siteKey={TURNSTILE_SECRET}
                                className={'mt-4 mx-auto max-w-fit'}
                                onError={() => setStatus('error')}
                                onExpire={() => setStatus('expired')}
                                onSuccess={() => setStatus('solved')}
                            />
                        )}
                </>
                }
                <p className="mt-4 text-sm text-center">
                    Vous avez déjà un compte ?{' '}
                    <button onClick={onConnexionBtnCLick} className="text-primary hover:underline">
                        Connectez-vous ici
                    </button>
                </p>
                <p className="mt-4 text-sm text-center">
                    Vous souhaitez emprunter ?{' '}
                    <HashLink
                        to="/emprunteur#fundingForm"
                        className="text-primary hover:underline"
                    >
                        Cliquez ici
                    </HashLink>
                </p>
            </div>
        </PageWrapper>

    );
};

export default Register;